export default function CDataTypes() {
  return <h2>C Data Types</h2>;
}
